import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ModalDialogService } from './../shared/modal-dialog/modal-dialog.service';
import { Dialog } from './../shared/modal-dialog/dialog.model';
import { ModalDialog2Service } from './../shared/modal-dialog2/modal-dialog.service';

import * as json from '../data/lista.json';


@Component({
    selector: 'app-offer-form',
    templateUrl: './offer-form.component.html',
    styleUrls: ['./offer-form.component.scss']
})
export class OfferFormComponent implements OnInit {
    form: FormGroup;
    formData = new FormData();
    dealers: any = [];

    private errorDialog: Dialog = { title: 'Przepraszamy.', text: 'Wystąpił błąd, spróbuj ponownie.', text2: '', text3: '' };
    private errorCodeDialog: Dialog = { title: 'Podany kod z Roblox jest nieprawidłowy.', text: '', text2: '', text3: '' };
    private errorCodeUsedDialog: Dialog = { title: 'Podany kod z Roblox został już wykorzystany.', text: '', text2: '', text3: '' };
    private errorCodeNoPrizeDialog: Dialog = { title: 'Podany kod z Roblox nie uprawnia do odbioru nagrody.', text: '', text2: '', text3: '' };
    private errorCodeVerificationDialog: Dialog = { title: 'Przepraszamy', text: 'Nie można zweryfikować kodu z Roblox, spróbuj ponownie później.', text2: '', text3: '' };
    private successDialog: Dialog = { title: 'Dziękujemy!', text: 'Podany kod jest prawidłowy ', text2: '', text3: '' };
    private tipCode: Dialog = { title: 'Gdzie znajdziesz swój unikalny kod?', text: 'Po wejściu do gry udaj się do wirtualnego Salonu Škody, podejdź do kolarza stojącego przy kaskach,  jeśli wygenerowałeś już swój unikalny kod to wyświetli Ci się on na komunikatorze.', text2: '', text3: '' };

    isBlocked = false;
    blockForm = true;
    isAdult = false;
    isSendError = false;
    blueBlocked = true;
    greenBlocked = true;
    whiteBlocked = true;
    purpleBlocked = true;

    isMoreInfoOpened = false;
    isMoreMoreInfoOpened = false;

    @Input() isMobileDevice: boolean;

    constructor(
        private fb: FormBuilder,
        private elem: ElementRef,
        private http: HttpClient,
        private modalDialogService: ModalDialogService,
        private modalDialog2Service: ModalDialog2Service

    ) {
        this.dealers = (json as any).default;
        this.dealers.sort((a: any, b: any) => a.miasto.localeCompare(b.miasto));
    }

    ngOnInit() {
        this.initForm();
        this.appendFieldsToFormData();
        // this.showPopUp();
        // this.modalDialogService.setModalDialog(this.successDialog);
    }

    initForm() {
        this.form = this.fb.group(
            {
                isAdult: false,
                name: ['', [Validators.required, Validators.pattern('^[A-Z-a-ząóęćłśńżźĄÓĘĆŁŚŃŻŹ ]{2,20}$')]],
                lastname: ['', [Validators.required, Validators.pattern('^[A-Z-a-ząóęćłśńżźĄÓĘĆŁŚŃŻŹ ]{2,20}$')]],
                robloxCode: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]{2,20}$')]],
                color: ['', Validators.required],
                regulaminAccept: ['', Validators.requiredTrue],
                dataAgreement: ['', Validators.requiredTrue],
                newsletterAgreement: false,
                newsletterMarketingAgreement: false,
                regulamin2Accept: false,

                // name: ['', [Validators.required, Validators.pattern('^[A-Z-a-ząóęćłśńżźĄÓĘĆŁŚŃŻŹ ]{2,20}$')]],
                phoneNo: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{9}$')]],
                email: ['', [, Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$')]],
                dealer: ['', Validators.required],

                // 'gdpr-answer-direct-marketing-importer': false,
                // 'gdpr-answer-email': false,
                // 'gdpr-answer-electronic-messages': false,
                // 'gdpr-answer-voice-calls': false
            }
        );
    }

    mapIfAdult() {
        this.form.value['isAdult'] = this.form.value['isAdult'] ? 1 : 0;
    }

    mapApprovalsValues() {
        this.form.value['gdpr-answer-direct-marketing-importer'] = this.form.value['gdpr-answer-direct-marketing-importer'] ? 1 : 0;
        this.form.value['gdpr-answer-email'] = this.form.value['gdpr-answer-email'] ? 1 : 0;
        this.form.value['gdpr-answer-electronic-messages'] = this.form.value['gdpr-answer-electronic-messages'] ? 1 : 0;
        this.form.value['gdpr-answer-voice-calls'] = this.form.value['gdpr-answer-voice-calls'] ? 1 : 0;
    }

    onInputChange(e, controlName) {
        this.form.patchValue({ [controlName]: e.target.value });
        this.checkApprovalsValues();
    }

    changeValue(e, controlName) {
        this.form.patchValue({ [controlName]: e.target.checked });
        if (controlName === 'isAdult') {
            this.isAdult = e.target.checked;
            console.log(this.isAdult);
        }
        this.checkApprovalsValues();

    }

    checkIfAdult() {
        if (this.form.value['isAdult'] === false) {
            this.blockForm = true;
        } else {
            this.blockForm = false;
        }
    }

    checkApprovalsValues() {
        if (this.isAdult === false) {
            this.isBlocked = true;
        } else {
            this.isBlocked = false;
        }
        if (!this.form.get('regulamin2Accept').value && (this.form.get('newsletterAgreement').value || this.form.get('newsletterMarketingAgreement').value)) {
            this.isBlocked = true;
        } else if (!this.form.get('newsletterAgreement').value && (this.form.get('regulamin2Accept').value || this.form.get('newsletterMarketingAgreement').value)) {
            this.isBlocked = true;
        } else if (!this.form.get('newsletterMarketingAgreement').value && (this.form.get('regulamin2Accept').value || this.form.get('newsletterAgreement').value)) {
            this.isBlocked = true;
        } else {
            this.isBlocked = false;
        }
    }

    onSubmitSuccessForm(orderId, formNameDataLayer, formNameSynerise) {
        const dataLayer = window['dataLayer'];
        dataLayer.push({
            event: 'formularze',
            'wypelniony-formularz': formNameDataLayer,
            orderid: orderId,
        });

        dataLayer.push({
            event: 'ga_event',
            eventCategory: 'formularze',
            eventAction: 'wypełniony formularz',
            eventLabel: 'oferta-zamowiono'
        });


        if (window['SyneriseTC']) {
            window['SyneriseTC'].sendFormData(formNameSynerise, {
                firstname: this.form.controls.name.value,
                lastname: this.form.controls.lastname.value,
                phone: this.form.controls.phoneNo.value,
                email: this.form.controls.email.value,
                dealer: this.form.controls.dealer.value,
            });
        }
    }

    sendForm() {
        let formNameSynerise = '';
        let formNameDataLayer = '';
        let formNameSyneriseNL = '';
        let formNameDataLayerNL = '';
        const apiUrl = 'https://fbods2.kampanie.skoda.pl/web/contest?key=er23riru8wefewfiewfief34mi43egergerge';
        const apiUrlNl = 'https://fbods2.kampanie.skoda.pl/web/handler/202310_Rowerowa_Planeta_Skody_Konkurs?key=er23riru8wefewfiewfief34mi43egergerge';
        this.checkApprovalsValues();
        if (this.form.valid && !this.isBlocked) {
            this.mapApprovalsValues();
            this.setValuesOfFormData();

            formNameSynerise = `bezpieczenstwo-rowerowe-dzieci-202310-konkurs`;
            formNameDataLayer = 'bezpieczenstwo-rowerowe-dzieci-202310-konkurs';
            formNameSyneriseNL = `bezpieczenstwo-rowerowe-dzieci-202310-konkurs`;
            formNameDataLayerNL = 'bezpieczenstwo-rowerowe-dzieci-202310-konkurs';

            this.http.post<{ externalId: string, success: boolean }>(apiUrl, this.formData).subscribe(
                response => {
                    if (response.success) {
                        this.modalDialogService.setModalDialog(this.successDialog);
                        this.setAlertMessageType();
                        this.onSubmitSuccessForm(response.externalId, formNameDataLayer, formNameSynerise);
                        if (this.formData.get('newsletter_agreement') === 'true') {
                            this.http.post<{ externalId: string, success: boolean }>(apiUrlNl, this.formData).subscribe(
                                data => {
                                    if (data.success) {
                                        // this.modalDialogService.setModalDialog(this.successDialog);
                                        // this.setAlertMessageType();
                                        this.onSubmitSuccessForm(data.externalId, formNameDataLayerNL, formNameSyneriseNL);
                                        this.resetForm();
                                        this.isBlocked = false;
                                        return true;
                                    } else {
                                        // this.modalDialogService.setModalDialog(this.errorDialog);
                                        return;
                                    }
                                },
                                error => {
                                    console.log(error);
                                    // console.log(error.error.error);
                                    // if (error.error.error === 'Formularz nie został podpięty do systemu') {
                                    //     console.log('błąd');
                                    // }
                                    // this.modalDialogService.setModalDialog(this.errorDialog);
                                }
                            );
                        } else {
                            this.resetForm();
                            this.isBlocked = false;
                            return true;
                        }
                    } else {
                        this.modalDialogService.setModalDialog(this.errorDialog);
                        return;
                    }
                },
                error => {
                    console.log(error);
                    if (error.error.error === 'Formularz nie został podpięty do systemu') {
                        console.log('błąd');
                        this.modalDialogService.setModalDialog(this.errorDialog);
                    } else if (error.error.error === 'Kod jest nieprawidłowy') {
                        this.modalDialogService.setModalDialog(this.errorCodeDialog);
                    } else if (error.error.error === 'Kod został już wykorzystany') {
                        this.modalDialogService.setModalDialog(this.errorCodeUsedDialog);
                    } else if (error.error.error === 'Kod nie uprawnia do odbioru nagrody') {
                        this.modalDialogService.setModalDialog(this.errorCodeNoPrizeDialog);
                    } else if (error.error.error === 'Nie można zweryfikować kodu, spróbuj później') {
                        this.modalDialogService.setModalDialog(this.errorCodeVerificationDialog);
                    } else {
                        this.modalDialogService.setModalDialog(this.errorDialog);
                    }
                }
            );
        }
    }

    private setAlertMessageType() {
        if (this.form.value['gdpr-answer-email'] && !(this.form.value['gdpr-answer-electronic-messages'] || this.form.value['gdpr-answer-voice-calls'])) {
        } else if (!this.form.value['gdpr-answer-email'] && (this.form.value['gdpr-answer-electronic-messages'] || this.form.value['gdpr-answer-voice-calls'])) {

        } else if (this.form.value['gdpr-answer-email'] && (this.form.value['gdpr-answer-electronic-messages'] || this.form.value['gdpr-answer-voice-calls'])) {
        } else {
        }
    }

    private appendFieldsToFormData() {
        // this.formData.append('formType', '');
        // this.formData.append('name', '');
        // this.formData.append('lastname', '');
        // this.formData.append('robloxCode', '');
        // this.formData.append('phoneNo', '');
        // this.formData.append('email', '');
        // this.formData.append('dealerName', '');
        // this.formData.append('dealerId', '');
        // this.formData.append('color', '');
        // this.formData.append('regulaminAccept', '');
        // this.formData.append('dataAgreement', '');
        // this.formData.append('newsletterAgreement', '');
        // this.formData.append('newsletterMarketingAgreement', '');
        // this.formData.append('regulamin2Accept', '');


        this.formData.append('formType', '');
        this.formData.append('contestType', '');
        this.formData.append('name', '');
        this.formData.append('surname', '');
        this.formData.append('phoneNo', '');
        this.formData.append('email', '');
        this.formData.append('dealerName', '');
        this.formData.append('dealerAddress', '');
        this.formData.append('code', '');
        this.formData.append('prizeVariant', '');
        this.formData.append('dealerId', '');
        this.formData.append('gdprNewsletterInfo', '');
        this.formData.append('gdprNewsletterDirectMarketing', '');
        this.formData.append('gdprNewsletterAccept', '');
        this.formData.append('newsletter_agreement', '');
        this.formData.append('newsletter_regulations', '');
    }

    private setValuesOfFormData() {
        this.formData.set('formType', 'submission');
        this.formData.set('contestType', 'childrenBicycleSafety');
        this.formData.set('name', this.form.value.name);
        this.formData.set('surname', this.form.value.lastname);
        this.formData.set('phoneNo', this.form.value.phoneNo);
        this.formData.set('email', this.form.value.email);
        this.formData.set('dealerName', `${this.form.value.dealer.miasto}, ${this.form.value.dealer.dealerName}`);
        this.formData.set('dealerAddress', `${this.form.value.dealer.street}`);
        this.formData.set('code', this.form.value.robloxCode);
        this.formData.set('prizeVariant', this.form.value.color);
        this.formData.set('dealerId', this.form.value.dealer.dealerId);
        this.formData.set('gdprNewsletterInfo', this.form.value.newsletterAgreement);
        this.formData.set('gdprNewsletterDirectMarketing', this.form.value.newsletterAgreement);
        this.formData.set('gdprNewsletterAccept', this.form.value.regulamin2Accept);

        this.formData.set('newsletter_agreement', this.form.value.newsletterMarketingAgreement);
        this.formData.set('newsletter_regulations', this.form.value.regulamin2Accept);

    }

    private resetForm() {
        this.form.reset();
        this.form.patchValue({
            name: '',
            lastname: '',
            robloxCode: '',
            phoneNo: '',
            email: '',
            dealer: '',
            color: '',
            regulaminAccept: false,
            dataAgreement: false,
            newsletterAgreement: false,
            newsletterMarketingAgreement: false,
            regulamin2Accept: false
        });
        this.isAdult = false;
    }

    showPopUp() {
        this.modalDialog2Service.setModalDialog(this.tipCode);
    }

    isBlueBlocked() {
        if (this.isAdult === false) {
            return '';
        } else {
            if (this.blueBlocked === true) {
                return '';
            } else {
                return null;
            }
        }
    }

    isGreenBlocked() {
        if (this.isAdult === false) {
            return '';
        } else {
            if (this.greenBlocked === true) {
                return '';
            } else {
                return null;
            }
        }
    }

    isWhiteBlocked() {
        if (this.isAdult === false) {
            return '';
        } else {
            if (this.whiteBlocked === true) {
                return '';
            } else {
                return null;
            }
        }
    }

    isPurpleBlocked() {
        if (this.isAdult === false) {
            return '';
        } else {
            if (this.purpleBlocked === true) {
                return '';
            } else {
                return null;
            }
        }
    }
}
